module.exports = __webpack_public_path__ + "static/Newspaper-e31dfc880b1c3626113c80d347e49d98.svg";